var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5V3.13346C5 2.38673 5 2.01308 5.14532 1.72786C5.27316 1.47698 5.47698 1.27316 5.72786 1.14532C6.01308 1 6.38673 1 7.13346 1H10.8668C11.6135 1 11.9867 1 12.2719 1.14532C12.5228 1.27316 12.727 1.47698 12.8548 1.72786C13.0001 2.01308 13.0001 2.38645 13.0001 3.13319V6.86654C13.0001 7.61327 13.0001 7.98664 12.8548 8.27186C12.727 8.52274 12.5226 8.72699 12.2717 8.85482C11.9868 9 11.614 9 10.8687 9H9M5 5H3.13346C2.38673 5 2.01308 5 1.72786 5.14532C1.47698 5.27316 1.27316 5.47698 1.14532 5.72786C1 6.01308 1 6.38673 1 7.13346V10.8668C1 11.6135 1 11.9867 1.14532 12.2719C1.27316 12.5228 1.47698 12.727 1.72786 12.8548C2.0128 13 2.386 13 3.13127 13H6.86903C7.61431 13 7.98698 13 8.27192 12.8548C8.5228 12.727 8.72699 12.5226 8.85482 12.2717C9 11.9868 9 11.614 9 10.8687V9M5 5H6.8668C7.61353 5 7.98671 5 8.27192 5.14532C8.5228 5.27316 8.72699 5.47698 8.85482 5.72786C9 6.0128 9 6.386 9 7.1313L9 9",
    stroke: "#989FAD",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.f4d3b6b49b7595c6b082512af07c4b9a.svg";
export { ForwardRef as ReactComponent };